import _ from 'lodash'
import cookie from 'js-cookie'
import { logger } from '@mypaas/app-render-engine/core/sdk'
import { metadataTransformer, METADATA_VERSION } from '@mypaas/app-metadata'
import * as API from '@api'
import * as THEME_API from '@api/theme'
import { getDevComponents } from '@api/dev'
import * as PageGroup from '@api/page-group'
import * as ObjectApi from '@api/object'
import * as T from './types'

export default {
    // 开发本地自定义组件
    [T.GET_LOCAL_COMPONENT]({ commit, state }) {
        return getDevComponents({
            devComponentHost: state.devComponentHost,
            devComponentPort: state.devComponentPort,
            teamCode: state.app.teamCode,
        }).then(res => {
            commit(T.SET_LOCAL_COMPONENT, res.data)
            return res.data
        }).catch(() => {
            logger.log('[paas] 未启动本地开发服务，不启动调试')
            return []
        })
    },
    // 应用
    [T.GET_APP_DETAIL]({ commit }, payload) {
        return API.getAppDetail(payload).then(res => {
            document.title = `移动建模平台 - ${res.workspaceName}`
            commit(T.SET_APP_DETAIL, res)
            return res
        })
    },
    [T.GET_APP_SETTING]({ commit }, payload) {
        return THEME_API.getSelectedTheme(payload).then(res => {
            // appSetting兼容
            const { global } = res.content || {}
            const appSetting = {
                body: {
                    header: {
                        hide: !(global.page.h5ShowHeader) || false,
                    },
                },
                style: {
                    primaryColor: global.color.primary,
                    secondaryColor: global.color.secondary,
                    globalBgColor: global.page.pageBgColor,
                },
            }
            commit(T.SET_APP_SETTING, { ...res.content, ...appSetting })
            return res.content
        })
    },
    [T.GET_VALID_PURVIEW]({ commit }, payload) {
        return API.getValidPurview(payload).then(res => {
            commit(T.SET_VALID_PURVIEW, res)
            return res
        })
    },
    [T.SET_APP_SETTING](store, payload) {
        return API.setAppSetting(payload)
    },
    [T.SAVE_APP_SETTING](store, payload) {
        return API.saveAppSetting(payload)
    },
    // 组件
    [T.GET_COMPONENTS](store, payload) {
        return API.getComponents(payload)
    },

    // 页面
    [T.GET_PAGES]({ commit, state, dispatch }, payload = {}) {
        const { app } = state
        return API.getPages({
            ...payload,
            appId: app?.appId,
        }).then(res => {
            commit(T.SET_PAGES, res)
            if (app?.isTenant) {
                dispatch(T.GET_VALID_PURVIEW, { appId: app?.appId })
            }
            return res
        })
    },
    [T.CREATE_PAGE](store, payload) {
        return API.createPage(payload)
    },
    [T.CREATE_PAGE_BY_TEMPLATE](store, payload) {
        return API.createPageByTemplate(payload)
    },
    [T.GET_PAGE_TEMPLATE](store, payload) {
        return API.getPageTemplate(payload)
    },
    [T.UPDATE_PAGE](store, payload) {
        return API.updatePage(payload)
    },
    [T.COPY_PAGE](store, payload) {
        return API.copyPage(payload)
    },
    [T.DELETE_PAGE](store, payload) {
        return API.deletePage({ ...payload })
    },
    [T.MOVE_PAGE](store, payload) {
        return API.movePage(payload)
    },
    [T.SET_LOGIN](store, payload) {
        return API.setLogin(payload)
    },
    [T.UNSET_LOGIN](store, payload) {
        return API.unsetLogin(payload)
    },
    [T.SET_HOME](store, payload) {
        return API.setHome(payload)
    },
    [T.SAVE_PAGE_META](store, payload) {
        return API.savePageMeta(payload)
    },

    [T.SAVE_NAVIGATION_META](store, payload) {
        return API.saveNavigationMeta(payload)
    },

    [T.SET_PAGE_STATUS](store, payload) {
        return API.updateStatus(payload)
    },

    [T.GET_SYSTEM_PAGES]({ commit }, payload) {
        return API.getSystemPages(payload).then(res => {
            commit(T.SET_SYSTEM_PAGES, res.item)
            return res
        })
    },
    [T.UPDATE_PAGE_META](store, payload) {
        return API.updatePageMeta(payload)
    },
    [T.UPDATE_PAGE_META_ALL](store, payload) {
        return API.updatePageMetaAll(payload)
    },
    [T.ALTER_PAGE_LOCKER]({ commit }, payload) {
        const { type, key, ...rest } = payload
        const loadingKey = `${key}-${type}`
        commit(T.SET_LOCKER_LOADING, { key: loadingKey, status: true })
        // 1 上锁，2 解锁, 3 强制上锁
        return API.alterPageLocker({
            ...rest,
            type,
        }).then(res => {
            if (type === 1) {
                if (res.lock) {
                    commit(T.SET_PAGE_LOCKER_ID, { key, lock: true })
                }
            } else if (type === 2) {
                commit(T.SET_PAGE_LOCKER_ID, { key, lock: false })
            } else if (type === 3) {
                commit(T.SET_PAGE_LOCKER_ID, { key, lock: true })
            }
            return res
        }).finally(() => {
            commit(T.SET_FIRST_LOCKER_LOADED, true)
            commit(T.SET_LOCKER_LOADING, { key: loadingKey, status: false })
        })
    },

    [T.UPDATE_PAGE_LOCKER_ID]({ commit }, payload) {
        commit(T.SET_PAGE_LOCKER_ID, payload)
    },

    [T.ALTER_PAGE]({ state, commit }, payload) {
        const { res } = payload
        const alterPage = (pages, page) => {
            const currentPages = _.cloneDeep(pages)
            for (let i = 0; i < currentPages.length; i++) {
                const oldPage = currentPages[i]
                const index = i
                if (oldPage && oldPage.pages && oldPage.pages.length) {
                    _.set(currentPages, index, {
                        ...oldPage,
                        pages: alterPage(oldPage.pages, page),
                    })
                }
                if (oldPage.id === page.id) {
                    _.set(currentPages, index, {
                        ...currentPages[index],
                        ...page,
                    })
                }
            }
            return currentPages
        }
        commit(T.SET_ASSIGNED_PAGE_LOADING, true)
        if (res && res.length) {
            let newPages = _.cloneDeep(state.pages)

            res.forEach(page => {
                newPages = alterPage(newPages, page)
            })

            commit(T.SET_PAGES, newPages)
        }
    },

    [T.GET_ASSIGNED_PAGE]({ commit, dispatch }, payload) {
        const { notRefresh, ...parameter } = payload
        commit(T.SET_ASSIGNED_PAGE_LOADING, true)
        return API.getAssignedPage(parameter).then(res => {
            const pages = res.map(r => ({
                ...r,
                metadata: r.metadata.version === METADATA_VERSION ? r.metadata : metadataTransformer(r.metadata, { isDesignModel: true }),
            }))
            !notRefresh && dispatch(T.ALTER_PAGE, { pages })
            return pages
        }).finally(() => {
            commit(T.SET_ASSIGNED_PAGE_LOADING, false)
        })
    },
    [T.GET_NAVIGATIONS]({ commit }, payload) {
        const { ...parameter } = payload || {}
        commit(T.SET_ASSIGNED_PAGE_LOADING, true)
        return API.getNavigations(parameter).finally(() => {
            commit(T.SET_ASSIGNED_PAGE_LOADING, false)
        })
    },
    [T.UPDATE_PAGE_BY_PAGEID]({ state, commit }, payload) {
        const { pageId, pagaData } = payload
        const pages = state?.pages?.map(page => {
            if (page.id === pageId) {
                return {
                    ...page,
                    ...pagaData,
                }
            }
            return page
        }) ?? []
        commit(T.SET_PAGES, pages)
    },
    // 文件夹
    [T.CREATE_FOLDER](store, payload) {
        return API.createFolder(payload)
    },
    [T.DELETE_FOLDER](store, payload) {
        return API.deleteFolder(payload)
    },
    [T.COPY_FOLDER](store, payload) {
        return API.copyFolder(payload)
    },
    [T.UPDATE_FOLDER](store, payload) {
        return API.updateFolder(payload)
    },

    // 配置
    [T.GET_CONF_LIST]({ commit }) {
        return API.getConfList().then(res => {
            commit(T.SET_CONF_LIST, res)
            return res
        })
    },
    [T.SAVE_CONF](store, payload) {
        return API.saveConf(payload)
    },

    [T.GET_SYSTEM_CONF_LIST]({ commit }, payload) {
        return API.getSystemConfList(payload).then(res => {
            commit(T.SET_SYSTEM_CONF_LIST, res.items)
            return res
        })
    },
    [T.GET_USER_LIST]({ commit }, payload) {
        return API.getUserList(payload).then(res => {
            commit(T.SET_USER_LIST, res.items)
            return res
        })
    },
    [T.ADD_CONF](store, payload) {
        return API.addConf(payload)
    },
    [T.SAVE_CONF_V2](store, payload) {
        return API.saveConfV2(payload)
    },
    [T.UPDATE_CONF](store, payload) {
        return API.updateConf(payload)
    },
    [T.UPDATE_CONF_ALL](store, payload) {
        return API.updateConfAll(payload)
    },
    [T.UPDATE_CONF_ALL_V2](store, payload) {
        return API.updateConfAllV2(payload)
    },
    [T.RESET_CONF](store, payload) {
        return API.resetConf(payload)
    },
    [T.DELETE_CONF](store, payload) {
        return API.deleteConf(payload)
    },
    [T.GET_METADATA_STATUS]({ commit, dispatch }, payload) {
        dispatch(T.GET_BUSINESS_ENV_DETAIL, payload)
        return API.getMetadataStatus().then(data => {
            commit(T.SET_METADATA_STATUS, data)
        })
    },

    [T.GET_BUSINESS_ENV_DETAIL]({ commit }, payload) {
        return API.getBusinessEnvDetail(payload).then(data => {
            commit(T.SET_BUSINESS_ENV_DETAIL, data)
        })
    },

    // 集成应用列表
    [T.GET_APP_LIST]({ commit }, payload) {
        return API.getAppList(payload)
            .then(data => {
                commit(T.SET_APP_LIST, data)
                return data
            })
            .catch(e => {
                if (e.code === 400) {
                    // 未配置 api 参数
                    commit(T.SET_APP_LIST)
                }
            })
    },

    // 小程序
    [T.MP_API](store, [channel, ...payload]) {
        return API[channel](...payload)
    },
    // designerRefresh
    [T.DESIGNER_REFRESH](store, payload) {
        return API.designerRefresh(payload)
    },

    // 获取模版列表
    [T.GET_TEMPLATE_LIST]({ commit }) {
        return API.getTemplateList().then(data => {
            commit(T.SET_TEMPLATE_LIST, data)
            return data
        })
    },

    // 模版上架
    [T.SET_TEMPLATE_STATUS](store, payload) {
        return API.setTemplateStatus(payload)
    },

    // 模版启用
    [T.USE_TEMPLATE]({ state, dispatch }, payload) {
        return API.useTemplate(payload).then(() => {
            const {
                app: {
                    id, webapp_version_id: versionId, template: { id: templateId },
                },
            } = state
            return dispatch(T.GET_APP_SETTING, { webappId: id, versionId, templateId }).then(() => Promise.all([
                dispatch(T.GET_SYSTEM_CONF_LIST, id),
                dispatch(T.GET_SYSTEM_PAGES, id),
                dispatch(T.GET_CONF_LIST),
                dispatch(T.GET_APP_LIST, id),
                dispatch(T.GET_PAGES, id),
                dispatch(T.GET_TEMPLATE_LIST),
            ]))
        }).catch(err => Promise.reject(err))
    },

    // 模版截图上传
    [T.UPDATE_TEMPLATE_COVER](store, payload) {
        return API.updateTemplateCover(payload)
    },
    // 图库
    [T.ADD_GALLERY_IMAGE](store, payload) {
        return API.addGalleryImage(payload)
    },
    [T.GET_OSS_CONFIG](store, payload) {
        return API.getAliOssSts(payload)
    },
    [T.GET_GALLERY_IMAGE](store, payload) {
        return API.getGalleryImage(payload)
    },
    [T.DELETE_GALLERY_IMAGE](store, payload) {
        return API.deleteGalleryImage(payload)
    },
    [T.UPDATE_GALLERY_IMAGE](store, payload) {
        return API.updateGalleryImage(payload)
    },
    [T.MOVE_GALLERY_IMAGE](store, payload) {
        return API.moveGalleryImage(payload)
    },
    [T.GET_GALLERY_GROUP](store, payload) {
        return API.getGalleryGroup(payload)
    },
    [T.CREATE_GALLERY_GROUP](store, payload) {
        return API.createGalleryGroup(payload)
    },
    [T.DELETE_GALLERY_GROUP](store, payload) {
        return API.deleteGalleryGroup(payload)
    },
    [T.MOVE_GALLERY_GROUP](store, payload) {
        return API.moveGalleryGroup(payload)
    },
    [T.UPDATE_GALLERY_GROUP](store, payload) {
        return API.updateGalleryGroup(payload)
    },

    [T.GET_ICON_INFO]({ commit }, payload) {
        return API.getIconInfo(payload).then(res => {
            commit(T.SET_ICON_INFO, res)
            return res
        })
    },
    // 操作指引
    [T.URI_ACCESS](store, payload) {
        return API.uriAccess(payload)
    },
    [T.URI_ACCESSED](store, payload) {
        return API.uriAccessed(payload)
    },

    //历史记录相关
    [T.GET_HISTORY_LISTS](store, payload) {
        return API.getHistory(payload)
    },
    //恢复历史记录
    [T.POST_HISTORY_RECOVER](store, payload) {
        return API.postRecover(payload)
    },
    //获取历史详情
    [T.GET_HISTORY_DETAIL](store, payload) {
        return API.getHistoryDetail(payload)
    },
    // 业务对象
    [T.GET_EXPRESSION_LIST](store, { webappId, objectId }) {
        return API.getExpressionList(webappId, objectId)
    },
    [T.GET_EXPRESSION](store, { webappId, objectId, id: expressionId }) {
        return API.getExpression(webappId, objectId, expressionId)
    },
    [T.CREATE_EXPRESSION](store, { webappId, objectId, ...expression }) {
        return API.createExpression(webappId, objectId, expression)
    },
    [T.DELETE_EXPRESSION](store, { webappId, objectId, id: expressionId }) {
        return API.deleteExpression(webappId, objectId, expressionId)
    },
    [T.UPDATE_EXPRESSION](store, { webappId, objectId, ...expression }) {
        return API.updateExpression(webappId, objectId, expression)
    },

    // 扩展代码
    [T.GET_FUNCTION_LIST]() {
        return API.getFunctionsList()
    },
    [T.ADD_FUNCTION](store, { webappId, webappCode, ...extendedfunction }) {
        return API.addFunction(webappId, webappCode, extendedfunction)
    },
    [T.BATCH_ADD_FUNCTION](store, { webappId, webappCode, payload }) {
        return API.batchAddFunction(webappId, webappCode, payload)
    },
    [T.EDIT_FUNCTION](store, {
        webappId, webappCode, id, ...extendedfunction
    }) {
        return API.editFunction(webappId, webappCode, id, extendedfunction)
    },
    [T.SAVE_FUNCTION](store, { id, content }) {
        return API.saveFunction(id, content)
    },
    [T.DELETE_FUNCTION](store, { webappId, webappCode, id }) {
        return API.deleteFunction(webappId, webappCode, id)
    },
    [T.BATCH_DELETE_FUNCTION](store, { webappId, webappCode, ...payload }) {
        return API.batchDeleteFunction(webappId, webappCode, payload)
    },
    [T.GET_USED_FUNCTION_LIST](store, { webappId, ...meta }) {
        return API.getUsedFunctionsList(webappId, meta)
    },
    [T.BUILD_FUNCTION](store, payload) {
        return API.buildFunction(payload)
    },
    [T.BATCH_BUILD_FUNCTION](store, payload) {
        return API.batchBuildFunction(payload)
    },

    // 校验函数
    [T.GET_VALIDATE_FUNCTION_LIST](store, { webappId, webappCode, ...payload }) {
        return API.getValidatorFunctionsList(webappId, webappCode, payload)
    },

    // data service
    [T.GET_DATA_OBJECT_LIST]() {
        return API.getDataObjectList()
    },
    [T.GET_DATA_SERVICE_LIST]() {
        return API.getDataServiceList()
    },

    // data expression
    [T.GET_DATA_EXPRESSION_LIST](store, {
        pageId,
    }) {
        return API.getDataExpressionList(pageId)
    },
    [T.GET_DATA_EXPRESSION](store, {
        pageId, id,
    }) {
        return API.getDataExpression(pageId, id)
    },
    [T.CREATE_DATA_EXPRESSION](store, {
        pageId, ...expression
    }) {
        return API.createDataExpression(pageId, { ...expression })
    },
    [T.DELETE_DATA_EXPRESSION](store, {
        pageId, id,
    }) {
        return API.deleteDataExpression(pageId, id)
    },
    [T.UPDATE_DATA_EXPRESSION](store, {
        pageId, ...expression
    }) {
        return API.updateDataExpression(pageId, { ...expression })
    },
    [T.UPDATE_PAGE_DATA_EXPRESSION]() {
        return Promise.resolve()
    },
    // 发布
    [T.ADD_VERSION](store, payload) {
        return API.addVersion(payload)
    },
    [T.PUBLISH_METADATA](store, payload) {
        return API.publishMetadata(payload)
    },
    [T.GET_WORKSPACE_ENV]() {
        return API.getWorkspaceEnv()
    },
    [T.GET_CATEGORY_VERSION](store, { category }) {
        return API.getCategoryVersion(category)
    },
    [T.BUILD_APP](store, payload) {
        return API.buildApp(payload)
    },
    [T.DEPLOYMENT_APP](store, payload) {
        return API.deploymentApp(payload)
    },
    [T.FETCH_META_DATA](store, payload) {
        return API.fetchMetaData(payload)
    },
    [T.GET_TOKEN]() {
        const myCookie = cookie.get('passport')
        const { host, protocol } = location
        const wsProtocol = protocol === 'http:' ? 'ws:' : 'wss:'
        const wsHostname = process.env.VUE_APP_BASE_WS_DOMAIN || host
        return {
            password: JSON.parse(window.atob(myCookie)).token,
            connectUrl: `${wsProtocol}//${wsHostname}/mqtt`,
            username: 'user',
        }
    },
    [T.SAVE_PREVIEW_TOKEN](store, payload) {
        return API.savePreviewToken(payload)
    },
    [T.REFRESH_TOKEN](store, payload) {
        return API.refreshToken(payload)
    },
    [T.INIT_APP]({ state, commit, dispatch }, payload = {}) {
        const { app } = state
        return API.getConfList(payload.appId, payload.appCode, payload.envId, payload.fromAppId, payload.fromEnvId).then(res => {
            commit(T.SET_CONF_LIST, res)
            if (app?.isTenant) {
                dispatch(T.GET_VALID_PURVIEW, { appId: app?.appId })
            }
            return res
        })
    },
    [T.GET_CHECK_ERROR_LIST](store, payload) {
        return API.getCheckErrorList(payload)
    },

    [T.GET_STAR_MAP_ENV](store, payload) {
        return API.getStarMapEnv(payload)
    },
    [T.GET_SERVICE_UPDATE]({ commit }, params) {
        return API.getServiceUpdate(params)
            .then(count => {
                commit(T.SET_TABS_MESSAGE_COUNT, {
                    type: 'service',
                    count,
                })
            })
    },
    [T.CREATE_PAGE_GROUP](store, payload) {
        return PageGroup.createGroup(payload)
    },
    [T.EDIT_PAGE_GROUP](store, payload) {
        return PageGroup.editGroup(payload)
    },
    [T.REMOVE_PAGE_GROUP](store, payload) {
        return PageGroup.removeGroup(payload)
    },
    [T.GET_OBJECT_DETAIL_BY_ID](store, payload) {
        const { objectId } = payload
        return ObjectApi.getObjectDetailId(objectId)
    },
    // 联动规则
    [T.GET_LINKAGE_LIST](store, payload) {
        return API.getLinkageList(payload)
    },
    [T.GET_LINKAGE_INFO](store, payload) {
        return API.getLinkageInfo(payload)
    },
    [T.ADD_LINKAGE](store, payload) {
        return API.addLinkage(payload)
    },
    [T.EDIT_LINKAGE_NAME](store, payload) {
        return API.editLinkageName(payload)
    },
    [T.EDIT_LINKAGE_INFO](store, payload) {
        return API.editLinkageInfo(payload)
    },
    [T.DELETE_LINKAGE](store, payload) {
        return API.deleteLinkage(payload)
    },
    [T.GET_IMAGE_LIBRARY_FOLDER]() {
        return API.getImageLibraryFolder()
    },
    [T.GET_IMAGE_LIBRARY](store, params) {
        return API.getImageLibrary(params)
    },
    [T.ADD_IMAGE_FOLDER](store, params) {
        return API.addImageFolder(params)
    },
    [T.ADD_IMAGES](store, params) {
        return API.addImages(params)
    },
    [T.DELETE_IMAGE](store, params) {
        const { id } = params
        return API.delImage(id)
    },
}
